import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import icon_close from "../../assets/01_Home/Close.svg";

/*eslint-disable */

declare const window: any;

interface HICSVehiculosComponentProps {
  banner: string; // Asegúrate de que el banner sea un string (URL del iframe).
  setVisibleHICS: (visible: boolean) => void;
  visibleHICS: boolean;
}

const HICSVehiculosComponent: React.FC<HICSVehiculosComponentProps> = ({
  banner,
  setVisibleHICS,
  visibleHICS,
}) => {
  const location = useLocation();
  const [iframeKey, setIframeKey] = useState(Date.now()); // Inicializa con una clave única.

  const selectedHICS = () => {
    setVisibleHICS(false);

    // Recargar el iframe generando una nueva clave.
    setIframeKey(Date.now());
  };

  const handleConScroll = () => {
    const bodyElement = document.body;
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    bodyElement.classList.add("active");
    bodyElement.style.paddingRight = `${scrollbarWidth}px`;

    const menuElement: HTMLElement | null =
      document.querySelector(".menu-layout");
    if (menuElement) {
      menuElement.style.paddingRight = `${scrollbarWidth}px`;
    }
  };

  const handleSinScroll = () => {
    const bodyElement = document.body;

    bodyElement.classList.remove("active");
    bodyElement.style.paddingRight = "";

    const menuElement: HTMLElement | null =
      document.querySelector(".menu-layout");
    if (menuElement) {
      menuElement.style.paddingRight = "";
    }
  };

  return (
    <div
      className={`hics-vehiculos-detail-component ${
        visibleHICS ? "visible" : ""
      }`}
    >
      <div
        className="close-hics-vehiculos-detail-component"
        onClick={() => selectedHICS()}
      >
        Salir
      </div>
      {/* Asigna la clave única al iframe para forzar su desmontaje y remontaje */}
      <iframe key={iframeKey} src={banner} title="HICS Vehículos"></iframe>
    </div>
  );
};

export default HICSVehiculosComponent;
